import { Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';

export interface BusinessInfoItem {
  uuid: string;
  name: string;
}

@Component({
  selector: 'app-business-select-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatListModule],
  template: `
    <h2 mat-dialog-title>Selecciona tu negocio</h2>
    <div mat-dialog-content>
      <p class="text-sm text-gray-600" *ngIf="items.length > 0">Elige con qué negocio quieres trabajar.</p>
      <mat-nav-list>
        <a mat-list-item class="c-pointer" *ngFor="let item of items" (click)="choose(item.uuid)">
          <div mat-line>{{ item.name || 'Sin nombre' }}</div>
          <div mat-line class="text-xs text-gray-500">{{ item.uuid }}</div>
        </a>
      </mat-nav-list>
      <div *ngIf="items.length === 0" class="text-sm text-gray-600">No hay negocios disponibles para seleccionar.</div>
    </div>
    <div mat-dialog-actions align="end">
      <button mat-stroked-button color="primary" (click)="close()">Cancelar</button>
    </div>
  `,
})
export class BusinessSelectDialogComponent implements OnInit {
  items: BusinessInfoItem[] = [];

  constructor(
    private ref: MatDialogRef<BusinessSelectDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { items: BusinessInfoItem[] }
  ) {}

  ngOnInit(): void {
    try {
      const list = Array.isArray(this.data?.items) ? this.data.items : [];
      this.items = list;
    } catch { this.items = []; }
  }

  choose(uuid: string) { this.ref.close(uuid); }
  close() { this.ref.close(null); }
}